export enum ErrorType {
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR',
}

const NotFound = ({
  errorType = ErrorType.NOT_FOUND,
}: {
  errorType?: ErrorType;
}) => {
  // TODO errorHandling: customise error page
  return <div>TODO Not found page: {errorType}</div>;
};

export default NotFound;
